import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import Reveal from "@/components/site/Reveal";

const items = [
  {
    q: "Comment se déroule une séance ?",
    a: "Chaque séance commence par un temps d'écoute et de clarification. Le travail s'adapte ensuite à votre problématique et à ce qui émerge pendant la séance.",
  },
  {
    q: "Quelle différence entre une séance individuelle et une constellation de groupe ?",
    a: "La séance individuelle permet un travail ciblé et intime. La constellation de groupe mobilise un cadre collectif qui met en lumière certaines dynamiques de façon complémentaire.",
  },
  {
    q: "Combien de séances faut-il prévoir ?",
    a: "Cela dépend de la situation. Une séance peut déjà apporter une compréhension importante, mais certaines problématiques demandent un travail sur plusieurs rendez-vous.",
  },
  {
    q: "Est-ce possible à distance ?",
    a: "Oui, certains accompagnements peuvent être proposés à distance selon la nature du travail.",
  },
  {
    q: "Comment savoir si cette approche me convient ?",
    a: "Si vous ressentez des blocages répétitifs, des réactions difficiles à comprendre ou l'impression que certains schémas se rejouent, cette approche peut être pertinente.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 bg-[#FAF7F8]"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="text-center">
            <span className="text-sm uppercase tracking-[0.2em] text-[#C98FA3] font-medium">
              — FAQ
            </span>
            <h2 className="font-serif-display text-4xl md:text-5xl font-light mt-4 leading-[1.05]">
              Questions fréquentes
            </h2>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-14 space-y-3">
            {items.map((it, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="bg-white rounded-2xl border border-[#DDD7E2] px-6 data-[state=open]:border-[#C98FA3] transition-colors"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-serif-display text-lg md:text-xl py-6 hover:no-underline text-[#1E1E2A]"
                >
                  {it.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="text-base text-[#5F6170] leading-relaxed pb-6"
                >
                  {it.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
